:host {
  width: inherit;
  font-family: var(--font-family sans);
  font-weight: var(--font-rg);
}

.panel-elem-container {
  width: 100%;
}

.panel-elem-icon {
  margin: auto calc(var(--space-unit) * 3);
}

.panel-elem-icon img {
  display: block;
  max-width: 96px;
  height: 32px;
  margin: auto;
  object-fit: contain;
}

.panel-elem-link {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: var(--space-unit) auto 0;
  border-radius: var(--border-no-radius);
  font-size: 12px;
}

.panel-elem-link > a.z-link {
  padding: calc(var(--space-unit) * 0.5) 0;
  font-weight: var(--font-sb);
}

.panel-elem-desc {
  padding-top: var(--space-unit);
  margin: 0;
  letter-spacing: 0.16px;
  text-align: center;
}

a > z-icon {
  margin-right: var(--space-unit);
}
